import type { MediaLightboxItem } from "~/shared/ui/media-lightbox";

import type { AttachmentKind } from "~/entities/chat";
import type { PickerImage } from "./useAttachmentPicker";

/** Таб-значение picker'а: "all" + конкретные attachment-kind'ы. */
export type PickerTabValue = "all" | AttachmentKind;

// Фильтрация по выбранному tab. Для "all" — все принимаемые kind'ы
// (acceptedKinds), для конкретного таба — только этот kind.
export function filterImagesByTab(
    images: PickerImage[],
    tab: PickerTabValue,
    acceptedKinds: AttachmentKind[],
): PickerImage[] {
    if (tab === "all") return images.filter((img) => acceptedKinds.includes(img.kind));
    return images.filter((img) => img.kind === tab);
}

// Lightbox только по image (audio/video preview не делаем здесь —
// отдельный VideoModal сложнее, оставляем как follow-up).
export function toLightboxImages(filteredImages: PickerImage[]): MediaLightboxItem[] {
    return filteredImages
        .filter((img) => img.kind === "image")
        .map((img) => ({ url: img.s3Url, type: "image" as const, caption: img.fileName }));
}

// Индекс В МАССИВЕ lightboxImages по s3Url (не в filteredImages — там
// могут быть video/audio которые мы пропускаем). null = не найдено.
export function findLightboxIndex(lightboxImages: MediaLightboxItem[], s3Url: string): number | null {
    const idx = lightboxImages.findIndex((x) => x.url === s3Url);
    return idx >= 0 ? idx : null;
}
